import { changeLayoutModeAction, changeFontSizeAction } from './reducer';

export const changeLayoutMode = (layoutMode) => async (dispatch) => {
    try {
        dispatch(changeLayoutModeAction(layoutMode));
    } catch (error) { }
};

export const changeFontSize = (fontSize) => async (dispatch) => {
    try {
        dispatch(changeFontSizeAction(fontSize));
    } catch (error) { }
};